import { WindowRef } from '../classes/window-ref.class';
import { BrowserWindowRef } from '../refs/browser-window.ref';
import { ClassProvider } from '@angular/core';

export const BROWSER_WINDOW_PROVIDER: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef,
};
